export default {"src":"/_next/static/media/hexagon-copy.ac2a7533.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};